import React from 'react'

import LoginHeader from './loginHeader';
import MainHeader from './MainHeader';
import { useSelector } from 'react-redux';
const Header = ({toggleDrawer,drawerStatus}) => {  
  const token = useSelector((state) => state.auth.token);
  return <LoginHeader toggleDrawer={toggleDrawer} drawerStatus={drawerStatus}   />
  // return token?<LoginHeader toggleDrawer={toggleDrawer} drawerStatus={drawerStatus}   />:null
}

export default Header